import React from 'react';

// Text of a big italic title with the home hero's look: the closing words carry the gradient.
// `words` is how many closing words get it (a one-word title is all gradient); `dark` is for
// titles on light backgrounds.
const TitleText = ({ text, words = 1, dark = false }) => {
    const parts = String(text || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return null;
    const cut = Math.max(0, parts.length - words);
    const head = parts.slice(0, cut).join(' ');
    return (
        <>
            {head && `${head} `}
            <span className={dark ? 'gradient-text-dark' : 'gradient-text'}>{parts.slice(cut).join(' ')}</span>
        </>
    );
};

export default TitleText;
